<script setup>
import Media from "@/components/media/Media.vue";
import FreePlan from "@/components/media/Freeplan.vue";
import Navi from "@/components/media/MediaNavi.vue";
import Help from "@/components/help/Help.vue";
</script>
<template>
<div class="media_area">
	<v-card width="100%" flat>
	<v-toolbar
		width="90%"
		height="45px"
		flat
		style="margin:0 auto;"
	>
		<v-spacer />
		<Help  />
	</v-toolbar>
	<v-card-text style="display:flex;" class="pt-0" v-if="pay_flg==true">
	<div class="media_list_area">
		<Media ref="list" />
	</div>
	<div class="media_aside">
		<Navi  class="media_menu_box" v-on:search="search_data($event)" />
	</div>
	</v-card-text>
	<v-card-text style="display:flex;justify-content:center;" v-else>
		<FreePlan />
	</v-card-text>
	</v-card>
</div>
</template>
<script>
export default {
  head: {
    title() {
      return {
        inner: 'WEBメディア一覧',
        separator: '|',
        complement: 'PR効果測定 Qlipper',
      }
    },
   link:
        [
          { rel: 'stylesheet', href: "https://qlipper.jp/css/common_vuetify.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/vuetify_custom.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/recom_doc_list.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/recom_dialog.css" },
          { rel: 'stylesheet', href: "./css/media.css" },
          { rel: 'stylesheet', href: "https://cdn.jsdelivr.net/npm/@mdi/font@7.3.67/css/materialdesignicons.min.css" },
        ],
   },

	computed : {
		pay_flg : function(){
			return this.$store.getters["member_info/get_pay_flg"];
		},
	},
	methods : {
		search_data : function(data){
			this.$refs.list.project_search(data);
		},
	},
}
</script>
